import { EmailOutlined, ReplyOutlined } from "@mui/icons-material";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import ConfusedMale from "../../../../components/artsPersonComponent/confusedMale";
import InformationMale from "../../../../components/artsPersonComponent/informationMale";
import TicketComponent from "../../../../components/tickets/ticketComponent";

const FluxoTickets = ({
  theme,
  styles,
  selectEtapaFluxo,
  isSelecting,
  allSelected,
  partiallySelected,
  selectedItems,
  handleSelectAll,
  handleToggleSelectMode,
  handleOpen,
  handleSelectItem,
  getTicketDetails,
  setSnackbar,
  labelErp,
  refreshAtendimentos,
  allEtapasFluxoAtendimentos,
  windowWidth,
  handleOpenModalEtapa,
  ingressar = () => {},
}) => {
  const atendimentos = selectEtapaFluxo?.atendimentos || [];
  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP || "";
  const isMobile = windowWidth <= 960;
  return (
    <Paper
      elevation={theme.palette.mode === "dark" ? 0 : 3}
      sx={styles.paperFluxoTickets}
    >
      {atendimentos.length > 0 && erp === "HUBSOFT" && (
        <Box sx={styles.containerButton}>
          <Box sx={styles.boxActions}>
            <Box sx={styles.containerActions}>
              {isSelecting && (
                <>
                  <Checkbox
                    checked={allSelected}
                    indeterminate={partiallySelected}
                    onChange={handleSelectAll}
                  />
                  <Typography sx={{ fontWeight: "bold", fontSize: 12 }}>
                    Selecionar todos
                  </Typography>
                </>
              )}
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Button
                size="small"
                variant={isSelecting ? "outlined" : "contained"}
                onClick={handleToggleSelectMode}
              >
                {isSelecting ? "Cancelar" : "Selecionar"}
              </Button>
              {isSelecting && (
                <Button
                  startIcon={<EmailOutlined />}
                  disabled={!selectedItems?.length}
                  size="small"
                  variant="contained"
                  onClick={handleOpen}
                  sx={
                    isMobile
                      ? {
                          minWidth: 36,
                          padding: "6px",
                          "& .MuiButton-startIcon": {
                            margin: 0,
                          },
                        }
                      : {}
                  }
                >
                  {!isMobile && "Criar mensagem"}
                </Button>
              )}

              {isSelecting && (
                <Button
                  startIcon={<ReplyOutlined />}
                  disabled={!selectedItems?.length}
                  size="small"
                  variant="contained"
                  onClick={handleOpenModalEtapa}
                  sx={
                    isMobile
                      ? {
                          minWidth: 36,
                          padding: "6px",
                          "& .MuiButton-startIcon": {
                            margin: 0,
                          },
                        }
                      : {}
                  }
                >
                  {!isMobile && "Encaminhar tickets"}
                </Button>
              )}
            </Box>
          </Box>
          <Divider />
        </Box>
      )}

      <Grid
        container
        spacing={2}
        sx={{ padding: "0 20px 20px 20px", mt: 1 }}
        columns={{ xs: 4, sm: 4, md: 8, lg: 8, xl: 8, xxl: 12 }}
      >
        {atendimentos.length > 0 ? (
          atendimentos.map((atendimento, key) => {
            const isSelected = selectedItems.some(
              (item) => item.id_atendimento === atendimento.id_atendimento,
            );

            return (
              <Grid item xs={4} sm={4} md={4} lg={4} key={key}>
                <Box
                  sx={{
                    ...styles.containerCheckBox,
                    border: isSelected
                      ? `2px solid ${theme.palette.primary.main}`
                      : "2px solid transparent",
                    position: "relative",
                  }}
                >
                  {isSelecting && (
                    <Checkbox
                      checked={isSelected}
                      onChange={() => handleSelectItem(atendimento)}
                      sx={styles.checkBox}
                    />
                  )}

                  <Box
                    sx={{
                      ...styles.checkOverlay,
                      backgroundColor: isSelected
                        ? theme.palette.primary.main
                        : "transparent",
                      opacity: isSelected ? 0.2 : 0,
                    }}
                  />

                  <TicketComponent
                    protocolo={atendimento?.protocolo}
                    descricao={atendimento?.descricao_abertura}
                    cliente={atendimento?.cliente?.nome || ""}
                    dataCadastro={dayjs(atendimento?.data_cadastro).format(
                      "DD/MM/YYYY",
                    )}
                    isEdit={true}
                    selectedCliente={atendimento?.isClienteAdd}
                    usuarioAbertura={atendimento?.usuario_abertura}
                    status={atendimento?.status}
                    ticketId={atendimento?.id_atendimento}
                    getTicketDetails={getTicketDetails}
                    setSnackbar={setSnackbar}
                    servicoId={atendimento?.idClienteServico || ""}
                    variantPaper="outlined"
                    labelErp={labelErp}
                    refreshAtendimentos={refreshAtendimentos}
                    percentSla={atendimento?.percentSla}
                    allEtapasFluxoAtendimentos={allEtapasFluxoAtendimentos}
                    historicoFluxoAtendimento={
                      atendimento?.historicoFluxoAtendimento
                    }
                    hiddenTimeLine={isSelecting}
                    allInfoTicket={atendimento}
                    ingressar={ingressar}
                  />
                </Box>
              </Grid>
            );
          })
        ) : selectEtapaFluxo ? (
          <Box sx={{ width: "100%", marginTop: 4 }}>
            <ConfusedMale
              mainFill={theme.palette.secondary.dark}
              primaryCircleFill={theme.palette.secondary.main}
              highlightTitle={"Oops!"}
              subtitle={`Parece que não há tickets\nrelacionados a etapa:`}
              highlightSubtitle={selectEtapaFluxo?.etapaFluxoAtendimento}
            />
          </Box>
        ) : (
          <Box
            sx={{
              width: "100%",
              marginTop: 4,
            }}
          >
            <InformationMale
              mainFill={theme.palette.secondary.dark}
              primaryCircleFill={theme.palette.secondary.main}
              secondaryCircleFill={theme.palette.secondary.light}
              title={"Você ainda não selecionou nenhuma"}
              highlight={"etapa do fluxo"}
              subtitle={
                "Os tickets relacionados a essa etapa\naparecerão assim que ela for escolhida."
              }
            />
          </Box>
        )}
      </Grid>
    </Paper>
  );
};

export default FluxoTickets;
